var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82812 21.666H11.625M1.5 4.33268V25.666C1.5 26.3733 1.76668 27.0515 2.24139 27.5516C2.71609 28.0517 3.35992 28.3327 4.03125 28.3327H19.2188C19.8901 28.3327 20.5339 28.0517 21.0086 27.5516C21.4833 27.0515 21.75 26.3733 21.75 25.666V10.122C21.75 9.76676 21.6825 9.4151 21.5517 9.08767C21.4209 8.76025 21.2292 8.46367 20.9881 8.21535L15.3687 2.42602C14.8958 1.93889 14.2608 1.6661 13.5994 1.66602H4.03125C3.35992 1.66602 2.71609 1.94697 2.24139 2.44706C1.76668 2.94716 1.5 3.62544 1.5 4.33268V4.33268ZM7.82812 16.3327H15.4219H7.82812Z",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.ab86a0e7c4a4c2751f38db2842d76af2.svg";
export { ForwardRef as ReactComponent };